module.exports = __webpack_public_path__ + "static/img/logo10.1e740ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo10.jpg
// module id = edTF
// module chunks = 2